import React from 'react'
import ReactTable from 'react-table'
import Utils from 'EurestoFonction/Utils'
import InfinityScroll from 'Components/InfinityScroll'
import Grid from '@material-ui/core/Grid'
import Bus from 'EurestoClass/Bus'

export default class extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      ...props,
      filtered: [],
      showDeleteModal: false,
      deleteModalLibelle: '',
      deleteModalKey: Utils.getRandomNumber(),
      cbDelete: undefined,
      selected: props.indexSelected,
      key: Utils.getRandomNumber(),
      key_name: Utils.uuidv4()
    }
  }

  componentDidUpdate () {
    $('#' + (this.props.id || this.state.key_name) + '-body').scrollTop(this.state.scrollBodyPosition)
  }

  render () {
    const data = this.state.data.results === undefined ? (this.state.data || []) : this.state.data.results
    const columns = this.state.columnsName
    const action = this.state.rowAction !== undefined ? this.state.rowAction : {}
    let pageSizeOptions = [5, 10, 20, 50, 100]

    let paginate = this.state.isSubComponent === undefined || this.state.isSubComponent === false
    /*if (this.state.isSubComponent === undefined || this.state.isSubComponent === false) {
      sizeOptions.map(length => {
        if (length <= data.length)
          pageSizeOptions.push(length)
      })
      if (sizeOptions.indexOf(data.length) === -1) {
        pageSizeOptions.push(data.length)
      }
    }*/
    let style = Object.assign({
      width: 'calc(100%)',
      maxWidth: 'calc(100%)',
      margin: 0,
      padding: 0,
      backgroundColor: 'white',
      cursor: this.props.onClick !== undefined ? 'pointer' : 'not-allowed',
    }, this.state.style || {})
    /*const height = parseInt($('body').css('height').replace('px', '')) - parseInt($('#MenuContainer').css('height').replace('px', ''))

    if (this.state.isSubComponent === undefined || this.state.isSubComponent === false) {
      style.height = height
    }*/
    let moreProps = {}
    if (this.props.hideHeader) {
      moreProps.TheadComponent = props => null
    }
    return (
      <Grid container style={{ position: 'relative', height: '100%' }}>
        <ReactTable
          filterable={false}
          filtered={false}
          key={this.state.key}
          id={this.props.id}
          className={'-striped -highlight ' + (this.props.className || '')}
          noDataText={''}
          previousText={EurestoI18n.t('Précédent')}
          nextText={EurestoI18n.t('Suivant')}
          loadingText={EurestoI18n.t('Patientez un instant...')}
          pageText={EurestoI18n.t('Page')}
          ofText={EurestoI18n.t('/')}
          rowsText={EurestoI18n.t('lignes')}
          data={data}
          pages={this.props.pages} // Display the total number of pages
          loading={this.props.loading} // Display the loading overlay when we need it
          onFetchData={this.props.fetchData} // Request new data when things change
          minRows={1}
          manual={this.props.manual}
          columns={columns}
          sortable
          multiSort
          onSortedChange={(a) => {
            Bus.$emit('sorted_search_' + this.props.search, a)
          }}
          defaultSorted={this.props.defaultSorted}
          showPagination={paginate}
          showPaginationTop={this.state.showPaginationTop === undefined || this.state.showPaginationTop === false ? false : true}
          showPaginationBottom={this.state.showPaginationBottom === false ? false : true}
          pageSizeOptions={pageSizeOptions}
          defaultPageSize={paginate ? 20 : data.length}
          SubComponent={this.state.gridSubComponent}
          style={style}
          getTbodyProps={(state, rowInfo, column, rtInstance) => {
            let id = (this.props.id || this.state.key_name) + '-body'
            return { id: id }
          }}
          getTableProps={(state, rowInfo, column, rtInstance) => {
            let id = (this.props.id || this.state.key_name) + '-table'
            return { id: id }
          }}
          defaultFilterMethod={(filter, row, column) => {
            const id = filter.pivotId || filter.id
            return row[id] !== undefined ? String(row[id]).toUpperCase().indexOf(filter.value.toUpperCase()) !== -1 : true
          }}
          onFilteredChange={filtered => this.setState({ filtered })}
          getTrProps={(state, rowInfo, column) => {
            const tdProps = {
              onContextMenu: (e) => {
                if (this.props.onContextMenuTr) {
                  e.preventDefault()
                  e.stopPropagation()
                  this.setState({
                    selected: this.props.toggleSelected && this.state.selected === rowInfo.index ? undefined : rowInfo.index,
                    scrollBodyPosition: $('#' + (this.props.id || this.state.key_name) + '-body').scrollTop(),
                  }, () => this.props.onContextMenuTr(rowInfo.original))
                }
              }
            }
            if (!(rowInfo === undefined || (rowInfo.original.type_saisie_id && Utils.isSubComponentAvailable(rowInfo.original.type_saisie_id)) || (rowInfo.original.type_saisie_id === undefined))) {
              tdProps['data-qnt'] = 0
            }
            if (rowInfo && rowInfo.index === this.state.selected) {
              tdProps.style = {
                border: '2px solid ' + EurestoColor('EurestoPrimary'),
                background: EurestoColor('EurestoSecondary'),
                color: EurestoColor('EurestoText'),
                borderRadius: 5
              }
            } else {
              tdProps.style = {
                border: '2px solid transparent',
              }
            }
            if (rowInfo && this.props.colorTD !== undefined) {
              const color = this.props.colorTD(rowInfo)
              tdProps.style = {
                ...(tdProps.style || {}),
                background: color.background || EurestoColor('EurestoSecondary'),
                //filter: 'invert(100%)',
                color: color.color || '#000000',
              }
            }
            return tdProps
          }}
          getTheadProps={(state, rowInfo, instance) => {
            let props = {
              onContextMenu: (e) => {
                e.preventDefault()
                e.stopPropagation()
              }
            }
            return props
          }}
          getTdProps={(state, rowInfo, column, instance) => {
            let onclick = {
              onClick: (e, cb) => {
                e.preventDefault()
                e.stopPropagation()
                if (this.props.onClick !== undefined || action[column.id] !== undefined) {
                  //if (action.default !== undefined || column.expander === true) {
                  this.setState({
                    selected: this.props.toggleSelected && this.state.selected === rowInfo.index ? undefined : rowInfo.index,
                    scrollBodyPosition: $('#' + (this.props.id || this.state.key_name) + '-body').scrollTop(),
                  })
                }
                if (action[column.id] !== undefined) {
                  if (action[column.id].condition === undefined || action[column.id].condition(rowInfo)) {
                    action[column.id].action(rowInfo.original)
                  }
                } else if (this.props.onClick !== undefined) {
                  this.props.onClick(rowInfo.original, rowInfo.index, e)
                } else if (column.cb && typeof cb === 'function') {
                  column.cb(rowInfo)
                } else {
                  if (cb && typeof cb === 'function') {
                    cb()
                  }
                }
                //}
              },
              onContextMenu: (e) => {
                if (this.props.onContextMenuTd && this.props.onContextMenuTd[column.id] !== undefined) {
                  e.preventDefault()
                  e.stopPropagation()
                  this.setState({
                    selected: this.state.selected === rowInfo.index ? undefined : rowInfo.index,
                    scrollBodyPosition: $('#' + (this.props.id || this.state.key_name) + '-body').scrollTop(),
                  }, () => this.props.onContextMenuTd[column.id](rowInfo.original)(e))
                }
              }
            }

            return onclick
          }}
          {...moreProps}
        />
        {this.props.infinityScroll && <InfinityScroll
          {...this.props.infinityScroll}
          search={this.props.search}
          element={() => $('#' + this.props.id + '-body')}/>}
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Datagrid/index.js